import { useTranslation } from "react-i18next";

import { Anchor, Button, Group, PasswordInput, Stack } from "@mantine/core";
import { useForm } from "@mantine/form";
import { useSearch } from "@tanstack/react-router";

import { useSignIn } from "@/api/resources/auth/hooks";
import FormFieldText from "@/components/Form/FormFieldText";
import loginFormSchema from "@/components/Login/loginFormSchema";
import { useNavigation } from "@/hooks/useNavigation";

export const LoginForm = () => {
  const { t } = useTranslation();
  const redirect = useSearch({ from: "/login", select: ({ redirect }) => redirect });
  const { goToRedirect, goToDashboard, goToRegister, goToForgotPassword } = useNavigation();

  const { mutate: signIn, isPending: loading } = useSignIn();

  const form = useForm({
    mode: "controlled",
    initialValues: {
      email: "",
      password: "",
    },
    validateInputOnChange: true,
    validateInputOnBlur: true,
    validate: loginFormSchema,
  });

  const onSubmit = form.onSubmit(({ email, password }) => {
    signIn(
      { email, password },
      {
        onSuccess: () => {
          // redirect original route or to index page (currentWorkspace determination)
          if (redirect) goToRedirect(redirect);
          else goToDashboard();
        },
      },
    );
  });

  return (
    <form onSubmit={onSubmit}>
      <Stack>
        <FormFieldText required label={t("mail")} key={form.key("email")} {...form.getInputProps("email")} />

        <PasswordInput
          required
          label={t("password")}
          placeholder={t("password")}
          key={form.key("password")}
          {...form.getInputProps("password")}
        />
      </Stack>

      <Group justify="space-between" mt="xl">
        <Anchor component="button" type="button" c="dimmed" onClick={goToRegister} size="xs">
          {t("create-new-account")}
        </Anchor>
        <Anchor component="button" type="button" c="dimmed" onClick={goToForgotPassword} size="xs">
          {t("forgot-password")}
        </Anchor>
        <Button size="md" type="submit" disabled={!form.isValid()} loading={loading} px="xl" fullWidth>
          {t("login")}
        </Button>
      </Group>
    </form>
  );
};

export default LoginForm;
